import { useEffect, useState } from 'react'
import apiClient from '@/shared/lib/apiClient'
import { tasksDashboardTaskNotesPath } from '@/shared/lib/routes'

// Task and NC cards of the same instrument task share one fetch per page session.
const taskNotesCache = new Map<number, string | null>()

/**
 * Task notes are rich text that can embed base64 images, so cards carry only
 * `hasTaskNotes` and fetch the notes once `enabled` (a form or dialog shows them).
 */
export const useTaskNotes = (instrumentTaskId: number | null, enabled: boolean): string | null => {
  const [, setLoadedTaskId] = useState<number | null>(null)

  useEffect(() => {
    if (!enabled || instrumentTaskId == null || taskNotesCache.has(instrumentTaskId)) return

    const controller = new AbortController()
    apiClient
      .get<{ notes: string | null }>(tasksDashboardTaskNotesPath(instrumentTaskId), {
        signal: controller.signal,
      })
      .then((response) => {
        taskNotesCache.set(instrumentTaskId, response.data.notes)
        setLoadedTaskId(instrumentTaskId)
      })
      .catch((error: unknown) => {
        if (!controller.signal.aborted) console.error('Failed to load task notes', error)
      })
    return () => controller.abort()
  }, [enabled, instrumentTaskId])

  return instrumentTaskId == null ? null : (taskNotesCache.get(instrumentTaskId) ?? null)
}
